import Editor from '@monaco-editor/react';
import { useState } from 'react';

interface Props {
  code: string;
  streaming: boolean;
}

export function CodePanel({ code, streaming }: Props): JSX.Element {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (): Promise<void> => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="relative flex-1 flex flex-col min-h-[280px]">
      <div className="flex items-center justify-between px-4 py-2 border-b border-border-subtle">
        <div className="flex items-center gap-2 text-xs text-neutral-500">
          <span className="inline-block w-2 h-2 rounded-full bg-accent" />
          User Variable — VBScript
          {streaming && <span className="text-accent ml-2 animate-pulse">streaming…</span>}
        </div>
        <button
          type="button"
          className="btn-secondary text-xs"
          onClick={handleCopy}
          disabled={!code}
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <div className="flex-1">
        <Editor
          height="100%"
          language="vb"
          theme="vs-dark"
          value={code}
          options={{
            readOnly: true,
            minimap: { enabled: false },
            fontSize: 13,
            scrollBeyondLastLine: false,
            lineNumbers: 'on',
            renderLineHighlight: 'none',
            wordWrap: 'on',
          }}
        />
      </div>
    </div>
  );
}
